import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  IBecomeMemberFromData,
  IMemberShipType,
} from "../../exports/interfaces";
import { marked } from "marked";
import qr from "../../assets/images/frcsit-qr-code2.png";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Fade } from "react-awesome-reveal";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";
import { useLoader } from "../../context/LoaderContext";
import axios from "axios";
import { dynamicFailed, dynamicSuccess, failed } from "../../hooks/useToast";
import { headers } from "../../exports/exports";
import { toWords } from "number-to-words";
import useMobile from "../../hooks/useMobile";
import { useLocation, useNavigate } from "react-router-dom";

const BecomeMemberForm = (props: {
  becomeMemberData: IBecomeMemberFromData[];
  token: string;
  membershipType: IMemberShipType[];
}) => {
  const { loading, setLoading } = useLoader();
  const mobile = useMobile();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  // const token = localStorage.getItem("frcsit:access-token");
  // const sisheaders = { Authorization: `Bearer ${token}` };
  const sisheaders = { Authorization: `Bearer ${props.token}` };
  const { companyDetailsData } = useCompanyDetailsContext();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [reenterPassword, setReenterPassword] = useState<string>("");
  const [firstname, setFirstname] = useState<string>("");
  const [middlename, setMiddlename] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [age, setAge] = useState<number | null>(null);
  const [sex, setSex] = useState<string>("");
  const [designation, setDesignation] = useState<string>("");
  const [qualifications, setQualifications] = useState<string>("");
  const [professionalAffiliations, setProfessionalAffiliations] =
    useState<string>("");
  const [mobilenumber, setMobileNumber] = useState<string>("");
  const [whatsappnumber, setWhatsappNumber] = useState<string>("");
  const [permanentAddress, setPermanentAddress] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [stateProvince, setStateProvince] = useState<string>("");
  const [postalZipCode, setPostalZipCode] = useState<number | null>(null);
  const [country, setCountry] = useState<string>("");
  const [workAddress, setWorkAddress] = useState<string>("");
  const [workCity, setWorkCity] = useState<string>("");
  const [workStateProvince, setWorkStateProvince] = useState<string>("");
  const [workPostalZipCode, setWorkPostalZipCode] = useState<number | null>(
    null
  );
  const [workCountry, setWorkCountry] = useState<string>("");
  const [proposer1Name, setProposer1Name] = useState<string>("");
  const [proposer1MembershipNumber, setProposer1MembershipNumber] = useState<
    number | null
  >(null);
  const [proposer2Name, setProposer2Name] = useState<string>("");
  const [proposer2MembershipNumber, setProposer2MembershipNumber] = useState<
    number | null
  >(null);
  const [membershipType, setMembershipType] = useState<string>("");
  const [membershipExpiry, setMembershipExpiry] = useState<number>(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File>();
  const [isPdf, setIsPdf] = useState(false);
  const memberData = location.state?.memberData;

  useEffect(() => {
    if (memberData) {
      setStep(4);
    }
    if (memberData && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [memberData]);

  const handleEditClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedFile(file);
      setPreview(url);
      setIsPdf(file.type === "application/pdf");
    }
  };

  useEffect(() => {
    if (props?.membershipType[0]?.attributes?.Expire_In_Yrs) {
      setMembershipExpiry(props?.membershipType[0]?.attributes?.Expire_In_Yrs);
      setMembershipType(
        `${props?.membershipType[0]?.attributes?.Title} ${
          props?.membershipType[0]?.attributes?.Expire_In_Yrs === 1
            ? "(ANNUALLY)"
            : `(${toWords(
                props?.membershipType[0]?.attributes?.Expire_In_Yrs
              ).toUpperCase()} YEARS)`
        }`
      );
    }
  }, [props?.membershipType]);

  const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"];
  const memberDetailsRef = useRef<HTMLDivElement>(null);
  const markedDescription = marked(
    props?.becomeMemberData[0]?.attributes?.Description || ""
  ) as string;
  const [step, setStep] = useState<number>(0);
  const [selectedMembership, setSelectedMembership] = useState<number | null>(
    1
  );
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleRePasswordVisibility = () => {
    setShowRePassword(!showRePassword);
  };
  const memberships = props.membershipType;
  const handleNext = () => {
    if (validateStep()) setStep((prev) => prev + 1);
    memberDetailsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSelectMembership = (membershipId: number) => {
    setSelectedMembership(membershipId);
  };

  const handlePrev = () => {
    setStep((prevStep) => prevStep - 1);
    memberDetailsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [receiptError, setReceiptError] = useState<{ [key: string]: string }>(
    {}
  );
  const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
  const validateStep = () => {
    let newErrors: { [key: string]: string } = {};
    if (step === 0) {
      if (!email) newErrors.email = "Email is required";
      else if (!isValidEmail(email)) newErrors.email = "Invalid email format";
      if (!password) {
        newErrors.password = "Password is required";
      } else if (password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      } else if (!/[A-Z]/.test(password)) {
        newErrors.password =
          "Password must contain at least one uppercase letter";
      } else if (!/\d/.test(password)) {
        newErrors.password = "Password must contain at least one number";
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        newErrors.password = "Password must contain at least one symbol";
      }
      if (!reenterPassword)
        newErrors.reenterPassword = "Please re-enter your password";
      else if (password !== reenterPassword)
        newErrors.reenterPassword = "Passwords do not match";
    }
    if (step === 1) {
      if (!firstname) newErrors.firstname = "First Name is required";
      if (!lastname) newErrors.lastname = "Last Name is required";

      if (!age) newErrors.age = "Age is required";
      if (!sex) newErrors.sex = "Please select a gender";

      if (!designation) newErrors.designation = "Designation is required";
      if (!qualifications)
        newErrors.qualifications = "Qualifications are required";
      if (!professionalAffiliations)
        newErrors.professionalAffiliations =
          "Professional Affiliations are required";
    }

    if (step === 2) {
      if (!mobilenumber) {
        newErrors.mobilenumber = "Mobile Number is required";
      } else if (!/^\d{10}$/.test(mobilenumber)) {
        newErrors.mobilenumber = "Mobile Number must be exactly 10 digits";
      }

      if (!permanentAddress)
        newErrors.permanentAddress = "Permanent Address is required";

      if (!city) newErrors.city = "City is required";
      if (!stateProvince)
        newErrors.stateProvince = "State/Province is required";

      if (!postalZipCode)
        newErrors.postalZipCode = "Postal/Zip Code is required";
      else if (postalZipCode.toString().length < 4)
        newErrors.postalZipCode =
          "Postal/Zip Code must be at least 4 digits long";

      if (!country) newErrors.country = "Country is required";
    }
    if (step === 3) {
      const isAnyProposerFilled =
        proposer1Name ||
        proposer1MembershipNumber ||
        proposer2Name ||
        proposer2MembershipNumber;

      if (isAnyProposerFilled && !isChecked) {
        newErrors.declaration = "You must declare the given information.";
      }
    }
    if (step === 4) {
      if (!selectedFile) {
        newErrors.selectedFile = "Payment receipt is required.";
      } else {
        const allowedTypes = [
          "image/png",
          "image/jpeg",
          "image/jpg",
          "application/pdf",
        ];
        if (!allowedTypes.includes(selectedFile.type)) {
          newErrors.selectedFile =
            "Only PNG, JPG, JPEG, or PDF files are allowed.";
        }
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePaymentReciept = () => {
    let newReceiptError: { [key: string]: string } = {};

    if (step === 4) {
      if (!selectedFile) {
        newReceiptError.selectedFile = "Payment receipt is required.";
      } else {
        const allowedTypes = [
          "image/png",
          "image/jpeg",
          "image/jpg",
          "application/pdf",
        ];
        if (!allowedTypes.includes(selectedFile.type)) {
          newReceiptError.selectedFile =
            "Only PNG, JPG, JPEG, or PDF files are allowed.";
        }
      }
    }

    setReceiptError(newReceiptError);
    return Object.keys(newReceiptError).length === 0;
  };

  const handleRenew = async () => {
    if (!validatePaymentReciept()) {
      return;
    }

    let uploadedId = null;
    setLoading(true);
    try {
      if (selectedFile) {
        const formData = new FormData();
        formData.append("files", selectedFile);

        const uploadRes = await axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/upload`,
          formData,
          {
            headers: {
              Authorization: headers.Authorization,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        uploadedId = uploadRes.data[0].id;
      }

      const oldPaymentReceipts =
        memberData[0]?.attributes?.Payment_Reciept?.data?.map(
          (item: { id: number }) => item.id
        ) || [];
      const updatedPaymentReceipts = [...oldPaymentReceipts, uploadedId].filter(
        Boolean
      );

      const data = {
        data: {
          Type_Of_Membership: membershipType,
          Membership_Valid: membershipExpiry,
          Status: "Pending",
          Payment_Reciept: updatedPaymentReceipts,
        },
      };
      axios
        .put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberData[0]?.id}`,
          data,
          {
            headers: headers,
          }
        )
        .then(async () => {
          navigate("/");
          dynamicSuccess('Successfull! payment pending')
          window.location.reload();
        })
        .catch(() => failed());
    } catch (e) {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!validatePaymentReciept()) {
      return;
    }
    let uploadedId = null;
    setLoading(true);
    try {
      const locationDetail = {
        area_name: "Chhauni",
        street_name: "Kakancho Binayak Marg",
        nearest_landmark: "",
        municipalities_id: 332,
        district_id: 28,
        province_id: 3,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_locationUrl}/location`,
        locationDetail,
        {
          headers: sisheaders,
        }
      );

      if (res?.status === 200 || res?.status === 201) {
        const userDetail = {
          name: firstname,
          phone_no: mobilenumber,
          address: JSON.stringify({
            area_name: { id: res?.data?.area_id },
            street_name: { id: res?.data?.street_id },
            nearest_landmark: "",
            municipalities_id: 332,
            district_id: 28,
            province_id: 3,
          }),
          email: email,
          gender: sex === "Male" ? 1 : 2,
          dob: "2000-01-01T00:00:00+05:45",
          password: password,
          password_confirmation: reenterPassword,
          status: 0,
          roles: ["member"],
          profile_pic: null,
        };
        const userRes = await axios.post(
          `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users`,
          userDetail,
          {
            headers: sisheaders,
          }
        );
        if (userRes?.data?.status === "success") {
          // const formattedDate = getFormattedDate(membershipExpiry, 0);
          // const formattedDate = getFormattedDate(0, -7);
          if (selectedFile) {
            const formData = new FormData();
            formData.append("files", selectedFile);

            const uploadRes = await axios.post(
              `${process.env.REACT_APP_strapiUrl}/api/upload`,
              formData,
              {
                headers: {
                  Authorization: headers.Authorization,
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            uploadedId = uploadRes.data[0].id;
          }
          const data = {
            data: {
              sis_id: String(userRes?.data?.user?.id),
              Email: email,
              First_Name: firstname,
              Middle_Name: middlename,
              Last_Name: lastname,
              Age: age,
              Sex: sex,
              Designation: designation,
              Qualifications: qualifications,
              Professional_Affiliations: professionalAffiliations,
              Mobile_Number: mobilenumber,
              WhatsAPP_Number: whatsappnumber,
              Permanent_Address: permanentAddress,
              City: city,
              State_Province: stateProvince,
              Postal_Zip_Code: postalZipCode,
              Country: country,
              Work_Address: workAddress,
              Work_City: workCity,
              Work_State_Province: workStateProvince,
              Work_Postal_Zip_Code: workPostalZipCode,
              Work_Country: workCountry,
              Full_Member_Name1: proposer1Name,
              Membership_Number1: proposer1MembershipNumber,
              Full_Member_Name2: proposer2Name,
              Membership_Number2: proposer2MembershipNumber,
              Type_Of_Membership: membershipType,
              Membership_Valid: membershipExpiry,
              Status: "Pending",
              Payment_Reciept: uploadedId,
            },
          };
          axios
            .post(`${process.env.REACT_APP_strapiUrl}/api/frcsit-users`, data, {
              headers: headers,
            })
            .then(() => {
              // const userDetail = {
              //   name: firstname,
              //   phone_no: mobilenumber,
              //   address: JSON.stringify({
              //     area_name: { id: res?.data?.area_id },
              //     street_name: { id: res?.data?.street_id },
              //     nearest_landmark: "",
              //     municipalities_id: 332,
              //     district_id: 28,
              //     province_id: 3,
              //   }),
              //   email: email,
              //   gender: sex === "Male" ? 1 : 2,
              //   dob: "2000-01-01T00:00:00+05:45",
              //   //   password: password,
              //   //   password_confirmation: reenterPassword,
              //   status: 0,
              //   roles: ["member"],
              //   profile_pic: null,
              // };
              // const userUpRes = await axios.put(
              //   `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users/${userRes?.data?.user?.id}`,
              //   userDetail,
              //   {
              //     headers: sisheaders,
              //   }
              // );
              // if (userUpRes?.data?.status === "success") {
                navigate("/");
                dynamicSuccess("User created successfully!");
              // }
            })
            .catch(() => failed());
        } else {
          dynamicFailed(userRes?.data?.message);
          setLoading(false);
        }
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <section className="become-volunteer">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-5">
            <div className="become-volunteer__Left">
              <div className="become-volunteer__images">
                <div className="row">
                  {!loading && (
                    <>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <Fade
                          cascade
                          damping={0.2}
                          direction="left"
                          triggerOnce={true}
                        >
                          <div className="become-volunteer__img-single">
                            <img
                              src={`${process.env.REACT_APP_strapiUrl}${props?.becomeMemberData[0]?.attributes?.First_Image?.data?.attributes?.url}`}
                              alt="member-img-one"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                        </Fade>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <Fade
                          cascade
                          damping={0.2}
                          direction="left"
                          delay={200}
                          triggerOnce={true}
                        >
                          <div className="become-volunteer__img-single">
                            <img
                              src={`${process.env.REACT_APP_strapiUrl}${props?.becomeMemberData[0]?.attributes?.Second_Image?.data?.attributes?.url}`}
                              alt="member-img-two"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                        </Fade>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="become-volunteer__content">
                <h3 className="become-volunteer__title">
                  {props?.becomeMemberData[0]?.attributes?.Title}
                </h3>
                <p
                  className="become-volunteer__text"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: markedDescription,
                  }}
                ></p>
                <div className="become-volunteer__btn-box">
                  <a
                    href={`${process.env.REACT_APP_strapiUrl}${props?.becomeMemberData[0]?.attributes?.File?.data?.attributes?.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="thm-btn become-volunteer__btn"
                  >
                    Download the Form
                  </a>
                </div>
                <div className="become-volunteer__contact">
                  <p>
                    <a
                      href={`tel:${companyDetailsData[0]?.attributes?.Phone_Number}`}
                      className="become-volunteer__phone"
                    >
                      {companyDetailsData[0]?.attributes?.Phone_Number}
                    </a>
                    <a
                      href={`mailto:${companyDetailsData[0]?.attributes?.Email}`}
                      className="become-volunteer__email"
                    >
                      {companyDetailsData[0]?.attributes?.Email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-lg-7">
            <div className="become-volunteer__right">
              <div className="custom-qr-section">
                <p
                  style={{
                    marginBottom: "0px",
                    textAlign: "center",
                    lineHeight: "25px",
                  }}
                >
                  For membership payment kindly make payment to QR code provided
                  below.
                </p>
                <img
                  src={qr}
                  alt="qr-image"
                  style={{
                    objectFit: "cover",
                    width: mobile ? "100%" : "50%",
                    height: mobile ? "100%" : "50%",
                  }}
                />
              </div>
              <div ref={memberDetailsRef}></div>
              <Stepper
                activeStep={step}
                alternativeLabel
                sx={{
                  marginTop: "40px",
                  marginBottom: "20px",
                  "& .MuiStepIcon-root.Mui-completed": {
                    color: "#ffa415",
                  },
                  "& .MuiStepIcon-root.Mui-active": {
                    color: "#ffa415",
                  },
                }}
              >
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <form className="become-volunteer__form" ref={formRef}>
                <div className="row">
                  {step === 0 && (
                    <>
                      <h3
                        className="become-volunteer__title"
                        style={{ marginTop: "20px" }}
                      >
                        Account Details
                      </h3>
                      <div className="col-xl-12">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Email ID*"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={errors.email && "error-border"}
                          />
                          {errors.email && (
                            <p className="error-message">{errors.email}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Password*"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={errors.password && "error-border"}
                          />

                          <i
                            className={`main-header-two__cart ${
                              showPassword ? "icon-eye-blocked" : "icon-eye"
                            } mini-cart__toggler custom-password-icon`}
                            onClick={togglePasswordVisibility}
                          ></i>
                        </div>
                        {errors.password && (
                          <p
                            className="error-message"
                            style={{
                              marginTop: "-30px",
                              marginBottom: "2.4em",
                            }}
                          >
                            {errors.password}
                          </p>
                        )}
                      </div>

                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type={showRePassword ? "text" : "password"}
                            placeholder="Re-enter Password*"
                            name="reenterpassword"
                            value={reenterPassword}
                            onChange={(e) => setReenterPassword(e.target.value)}
                            className={errors.password && "error-border"}
                          />

                          <i
                            className={`main-header-two__cart ${
                              showRePassword ? "icon-eye-blocked" : "icon-eye"
                            } mini-cart__toggler custom-password-icon`}
                            onClick={toggleRePasswordVisibility}
                          ></i>
                        </div>
                        {errors.password && (
                          <p
                            className="error-message"
                            style={{
                              marginTop: "-30px",
                              marginBottom: "2.4em",
                            }}
                          >
                            {errors.password}
                          </p>
                        )}
                      </div>
                    </>
                  )}
                  {step === 1 && (
                    <>
                      <h3
                        className="become-volunteer__title"
                        style={{ marginTop: "20px" }}
                      >
                        Personal Details
                      </h3>
                      <div className="col-xl-4">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="First Name*"
                            name="firstname"
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}
                            className={errors.firstname && "error-border"}
                          />
                          {errors.firstname && (
                            <p className="error-message">{errors.firstname}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Middle Name"
                            name="middlename"
                            value={middlename}
                            onChange={(e) => setMiddlename(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Last Name*"
                            name="lastname"
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}
                            className={errors.lastname && "error-border"}
                          />
                          {errors.lastname && (
                            <p className="error-message">{errors.lastname}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="Age*"
                            name="age"
                            value={age || ""}
                            onChange={(e) => setAge(Number(e.target.value))}
                            className={errors.age && "error-border"}
                          />
                          {errors.age && (
                            <p className="error-message">{errors.age}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="become-volunteer__input">
                          <select
                            name="sex"
                            className={`become-volunteer__select ${
                              errors.sex && "error-border"
                            }`}
                            defaultValue=""
                            value={sex}
                            onChange={(e) => setSex(e.target.value)}
                          >
                            <option value="" disabled>
                              Sex*
                            </option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                          {errors.sex && (
                            <p className="error-message">{errors.sex}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Designation*"
                            name="designation"
                            value={designation}
                            onChange={(e) => setDesignation(e.target.value)}
                            className={errors.designation && "error-border"}
                          />
                          {errors.designation && (
                            <p className="error-message">
                              {errors.designation}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input become-volunteer__message-box">
                          <textarea
                            name="qualifications"
                            placeholder="Qualifications*"
                            value={qualifications}
                            onChange={(e) => setQualifications(e.target.value)}
                            className={errors.qualifications && "error-border"}
                          ></textarea>
                          {errors.qualifications && (
                            <p className="error-message">
                              {errors.qualifications}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input become-volunteer__message-box">
                          <textarea
                            name="professionalaffiliations"
                            placeholder="Professional Affiliations*"
                            value={professionalAffiliations}
                            onChange={(e) =>
                              setProfessionalAffiliations(e.target.value)
                            }
                            className={
                              errors.professionalAffiliations && "error-border"
                            }
                          ></textarea>
                          {errors.professionalAffiliations && (
                            <p className="error-message">
                              {errors.professionalAffiliations}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <h3
                        className="become-volunteer__title"
                        style={{ marginTop: "20px" }}
                      >
                        Contact Details
                      </h3>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="Mobile Number*"
                            name="mobilenumber"
                            value={mobilenumber}
                            onChange={(e) => setMobileNumber(e.target.value)}
                            className={errors.mobilenumber && "error-border"}
                          />
                          {errors.mobilenumber && (
                            <p className="error-message">
                              {errors.mobilenumber}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="WhatsAPP Number"
                            name="whatsappnumber"
                            value={whatsappnumber}
                            onChange={(e) => setWhatsappNumber(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Permanent Address*"
                            name="permanentaddress"
                            value={permanentAddress}
                            onChange={(e) =>
                              setPermanentAddress(e.target.value)
                            }
                            className={
                              errors.permanentAddress && "error-border"
                            }
                          />
                          {errors.permanentAddress && (
                            <p className="error-message">
                              {errors.permanentAddress}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <select
                            name="city"
                            className={`become-volunteer__select ${
                              errors.city && "error-border"
                            }`}
                            defaultValue=""
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          >
                            <option value="" disabled>
                              City*
                            </option>
                            <option value="Kathmandu">Kathmandu</option>
                          </select>
                          {errors.city && (
                            <p className="error-message">{errors.city}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <select
                            name="stateprovince"
                            className={`become-volunteer__select ${
                              errors.stateProvince && "error-border"
                            }`}
                            defaultValue=""
                            value={stateProvince}
                            onChange={(e) => setStateProvince(e.target.value)}
                          >
                            <option value="" disabled>
                              State/Province*
                            </option>
                            <option value="Bagmati">Bagmati</option>
                          </select>
                          {errors.stateProvince && (
                            <p className="error-message">
                              {errors.stateProvince}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="Postal/Zip Code*"
                            name="postalzipcode"
                            value={postalZipCode || ""}
                            onChange={(e) =>
                              setPostalZipCode(Number(e.target.value))
                            }
                            className={errors.postalZipCode && "error-border"}
                          />
                          {errors.postalZipCode && (
                            <p className="error-message">
                              {errors.postalZipCode}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <select
                            name="country"
                            className={`become-volunteer__select ${
                              errors.country && "error-border"
                            }`}
                            defaultValue=""
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                          >
                            <option value="" disabled>
                              Country*
                            </option>
                            <option value="Nepal">Nepal</option>
                          </select>
                          {errors.country && (
                            <p className="error-message">{errors.country}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Work Address"
                            name="workaddress"
                            value={workAddress}
                            onChange={(e) => setWorkAddress(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <select
                            name="city"
                            className="become-volunteer__select"
                            defaultValue=""
                            value={workCity}
                            onChange={(e) => setWorkCity(e.target.value)}
                          >
                            <option value="" disabled>
                              City
                            </option>
                            <option value="Kathmandu">Kathmandu</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <select
                            name="stateprovince"
                            className="become-volunteer__select"
                            defaultValue=""
                            value={workStateProvince}
                            onChange={(e) =>
                              setWorkStateProvince(e.target.value)
                            }
                          >
                            <option value="" disabled>
                              State/Province
                            </option>
                            <option value="Bagmati">Bagmati</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="Postal/Zip Code"
                            name="postalzipcode"
                            value={workPostalZipCode || ""}
                            onChange={(e) =>
                              setWorkPostalZipCode(Number(e.target.value))
                            }
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <select
                            name="country"
                            className="become-volunteer__select"
                            defaultValue=""
                            value={workCountry}
                            onChange={(e) => setWorkCountry(e.target.value)}
                          >
                            <option value="" disabled>
                              Country
                            </option>
                            <option value="Nepal">Nepal</option>
                          </select>
                        </div>
                      </div>
                    </>
                  )}
                  {step === 3 && (
                    <>
                      <h3
                        className="become-volunteer__title"
                        style={{ marginTop: "20px" }}
                      >
                        Proposed By
                      </h3>
                      <h6 className="become-volunteer__sub-title">
                        Full Member Number 1
                      </h6>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Name"
                            name="name"
                            value={proposer1Name}
                            onChange={(e) => setProposer1Name(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="Membership Number"
                            name="membershipnumber"
                            value={proposer1MembershipNumber || ""}
                            onChange={(e) =>
                              setProposer1MembershipNumber(
                                Number(e.target.value)
                              )
                            }
                          />
                        </div>
                      </div>
                      <h6 className="become-volunteer__sub-title">
                        Full Member Number 2
                      </h6>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="text"
                            placeholder="Name"
                            name="name"
                            value={proposer2Name}
                            onChange={(e) => setProposer2Name(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="become-volunteer__input">
                          <input
                            type="number"
                            placeholder="Membership Number"
                            name="membershipnumber"
                            value={proposer2MembershipNumber || ""}
                            onChange={(e) =>
                              setProposer2MembershipNumber(
                                Number(e.target.value)
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="become-volunteer__input">
                          <p
                            style={{
                              fontSize: "12px",
                              lineHeight: "15px",
                              color: "#ffa415",
                            }}
                          >
                            Recommendation from a full member is desirable for
                            approval, but not mandatory. The member number is
                            not required.
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <input
                              type="checkbox"
                              id="declaration"
                              checked={isChecked}
                              onChange={(e) => setIsChecked(e.target.checked)}
                              style={{
                                accentColor: "#ffa415",
                                width: "12px",
                                height: "12px",
                                cursor: "pointer",
                              }}
                            />
                            <label
                              htmlFor="declaration"
                              style={{
                                fontSize: "12px",
                                lineHeight: "15px",
                                cursor: "pointer",
                              }}
                            >
                              I declare that information given is true to the
                              best of my knowledge
                            </label>
                          </div>
                          {errors.declaration && (
                            <p
                              className="error-message"
                              style={{ marginLeft: "20px" }}
                            >
                              {errors.declaration}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {step === 4 && (
                    <>
                      <h3
                        className="become-volunteer__title"
                        style={{ marginTop: "20px" }}
                      >
                        Type Of Membership
                      </h3>

                      {memberships.map((membership) => (
                        <div
                          key={membership.id}
                          className="col-xl-12"
                          style={{ display: "flex", marginBottom: "10px" }}
                        >
                          <div className="membership-radio-container">
                            <input
                              type="radio"
                              name="membership"
                              checked={selectedMembership === membership.id}
                              onChange={() => {
                                handleSelectMembership(membership.id);
                                setMembershipType(
                                  `${membership.attributes.Title} ${
                                    membership.attributes.Expire_In_Yrs === 1
                                      ? "(ANNUALLY)"
                                      : `(${toWords(
                                          membership.attributes.Expire_In_Yrs
                                        ).toUpperCase()} YEARS)`
                                  }`
                                );
                                setMembershipExpiry(
                                  membership.attributes.Expire_In_Yrs
                                );
                              }}
                            />
                          </div>
                          <div
                            className="membership-card"
                            style={{
                              backgroundColor:
                                selectedMembership === membership.id
                                  ? "#f2f0ec"
                                  : "",
                            }}
                          >
                            <div className="membership-content">
                              <h3>
                                {membership.attributes.Title}{" "}
                                {membership.attributes.Expire_In_Yrs === 1
                                  ? "(ANNUALLY)"
                                  : `(${toWords(
                                      membership.attributes.Expire_In_Yrs
                                    ).toUpperCase()} YEARS)`}
                              </h3>
                              <p>{membership.attributes.Description}</p>
                              {membership.attributes.Price_Details && (
                                <span className="membership-price">
                                  {membership.attributes.Price_Details}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                      {/* {selectedMembership === 5 && (
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="Affiliate Reference Number*"
                              name="affiliatereferencenumber"
                            />
                          </div>
                        </div>
                      )} */}

                      <div className="col-xl-12" style={{ marginTop: "30px" }}>
                        <div className="become-volunteer__input custom-file-input">
                          {preview ? (
                            <>
                              <div
                                className="user-card__image"
                                style={{ cursor: "default" }}
                              >
                                {isPdf ? (
                                  <iframe
                                    src={preview}
                                    title="PDF Preview"
                                    style={{
                                      width: "80px",
                                      height: "80px",
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                ) : (
                                  <img src={preview} alt="Preview" />
                                )}

                                <div
                                  className="edit-profil-pic-icon"
                                  style={{ top: "0px", left: "65px" }}
                                  onClick={handleEditClick}
                                >
                                  <span className="icon-pencil"></span>
                                </div>
                              </div>
                              <input
                                type="file"
                                accept=".png,.jpg,.jpeg,.pdf"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                            </>
                          ) : (
                            <>
                              <label
                                htmlFor="profile-image-upload"
                                style={{ cursor: "pointer" }}
                              >
                                Upload Payment Receipt* (.png, .jpg, .jpeg,
                                .pdf)
                              </label>
                              <input
                                type="file"
                                id="profile-image-upload"
                                accept=".png,.jpg,.jpeg,.pdf"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                              />
                            </>
                          )}
                          {receiptError.selectedFile && (
                            <p className="error-message">
                              {receiptError.selectedFile}
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </form>
              <div className="become-volunteer__btn-container">
                {step > 0 && (
                  <button
                    onClick={handlePrev}
                    className="thm-btn become-volunteer__btn become-volunteer__prev-btn"
                    disabled={memberData}
                    style={{
                      cursor: memberData ? "not-allowed" : "pointer",
                      opacity: memberData ? 0.5 : 1,
                    }}
                  >
                    <i className="icon-arrow-left2"></i>
                    Back
                  </button>
                )}
                {step < 4 ? (
                  <button
                    onClick={handleNext}
                    className="thm-btn become-volunteer__btn become-volunteer__next-btn"
                  >
                    Next
                    <i className="icon-arrow-right2"></i>
                  </button>
                ) : (
                  <div className="become-volunteer__btn-box">
                    <button
                      type="submit"
                      className="thm-btn become-volunteer__btn become-volunteer__submit"
                      onClick={() => {
                        memberData ? handleRenew() : handleSubmit();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BecomeMemberForm;
